import CodeServiceModel               from '@/models/CodeServiceModel';
import doc                            from '@widesk-core/decorators/doc';
import model                          from '@widesk-core/decorators/model';
import CodeTypeModel                  from './CodeTypeModel';
import CodeTypePropertyModel          from './CodeTypePropertyModel';
import { CodeTypePropertyReference }  from './CodeTypePropertyModel';

@model.urnResource('code_type_property_value')
@doc.path('/code_type_property_values/{?id}')
export default class CodeTypePropertyValueModel extends CodeServiceModel {
	private declare _tsFilters: {
		'codeType': id;
		'codeTypeProperty': id;
		'codeTypeProperty.reference': CodeTypePropertyReference;
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(CodeTypeModel) declare codeType: CodeTypeModel;
	@doc.model(CodeTypePropertyModel) declare codeTypeProperty: CodeTypePropertyModel;
	@doc.string declare value: string;
}